import { render } from "./ButtonRoute.vue?vue&type=template&id=b3d90182"
import script from "./ButtonRoute.vue?vue&type=script&lang=js"
export * from "./ButtonRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__